import React, { Component } from 'react';
class ConvertToScheduleConsultation extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){

}


  render() {
    return (
        <>
        <div className="modal fade" id="myModal" role="dialog">
          <div className="modal-dialog popup_view_width">
            <div className="modal-content">
              <div className="modal-header">
              <h4 className="modal-title" id="page_titlte">Convert Schedule Consultation</h4>
                <button type="button" className="close" data-dismiss="modal" onClick={this.props.close_popup_view}>&times;</button>
              </div>
              <div className="modal-body">


              <div className="">
              <div className="col-md-12">
                  <div className="wow fadeInUp" data-wow-delay="0.5s">
                      <form action="" method="post">
                      <div className="row g-3">

                      <div className="col-md-4">
                          <div className="form-floating">
                              <input type="text" className="form-control" id="name" placeholder="Event Title" readOnly="true" value={this.props.first_name+" "+this.props.last_name}/>
                              <label for="name">Full Name</label>
                          </div>
                      </div>

                      <div className="col-md-4">
                          <div className="form-floating">
                              <input type="text" className="form-control" id="name" placeholder="Event Title" readOnly="true" value={this.props.email}/>
                              <label for="name">Email</label>
                          </div>
                      </div>

                      <div className="col-md-4">
                          <div className="form-floating">
                              <input type="text" className="form-control" id="name" placeholder="Event Title" readOnly="true" value={this.props.mobile_no}/>
                              <label for="name">Mobile Number</label>
                          </div>
                      </div>

                      <div className="col-md-12">
                        <div className="col-md-2 p-0 float_r">
                            <button className="btn btn-primary w-100 py-3" type="button">Submit</button>
                        </div>
                      </div>

                      </div>
                      </form>
                  </div>
              </div>
              </div>


              </div>
            </div>
          </div>
        </div>


        </>
    );
  }
}

export default ConvertToScheduleConsultation;
